<template>
  <!-- csst -->
  <div
    class="text-noselect f-center"
    style="--cssm-z-index: 10"
    @click="
      e => {
        open = !open
        $nextTick(() => {
          fl_positionMenu(e, { placement: 'bottom-end' })
        })
      }
    "
  >
    <div v-html="selectedItem.text"></div>
    <div
      class="mdi mdi-chevron-down ml-1 text-semi-large line-height_1 pa-1 icon_btn clr-white"
    ></div>
    <!-- <div
      class="csst_content text-nowrap clr-white"
      style="top: -1.75em; right: 0"
      v-html="$t('tooltips.trainer_result_view')"
    ></div> -->
    <div
      :class="open ? 'cssm_content cssm_content_visible' : 'cssm_content_not-visible'"
      style="position: fixed"
      @click.stop="
        e => {
          let ee = { currentTarget: e.currentTarget.parentElement }
          fl_positionMenu(ee, { placement: 'bottom-end' })
        }
      "
    >
      <div
        v-if="open"
        v-click-outside="() => (open = false)"
        class="trainer-table-controls dasharticleswitch"
        @click="open = false"
      >
        <div
          v-for="item in items"
          :key="item.payload"
          class="gw_btn gw_btn_text text-nowrap"
          :class="{ gw_btn_active: item.active }"
          style="--radius: 0; --padding: 0 0.75rem; --clr-active-white: var(--clr-black-2)"
          @click="handleClick(item)"
        >
          <!-- <i class="mdi text-semi-large mr-2" :class="item.icon"></i> -->
          <div
            class="mr-auto text-medium"
            v-html="item.text"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerResultChartSwitcher',
  mixins: [float_mix],
  props: {
    value: String,
    // namespace: { String, required: true },
  },
  emits: ['update'],
  data() {
    return {
      open: false,
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('update', item)
    },
  },
  computed: {
    selectedItem() {
      return this.items.find(i => i.active)
    },
    items() {
      let res = [
        { payload: '', text: this.$t('dashboard_articles.all') },
        { payload: 'video', text: this.$t('dashboard_articles.types.video') },
        { payload: 'announcement', text: this.$t('dashboard_articles.types.announcement') },
        { payload: 'article', text: this.$t('dashboard_articles.types.article') },
        // { payload: 'coaching', text: this.$t('dashboard_articles.types.coaching') },
      ]
      res = res.map(i => {
        const r = {
          ...i,
          active: this.value === i.payload,
        }
        return r
      })
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.dasharticleswitch {
  &_opener {
    text-shadow: var(--text-shadow_outlined);
    font-size: 1.25rem;
    height: 2rem;
    width: 2rem;
  }
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  max-height: var(--vh-3);
  background: var(--clr-black-1);
  padding: 0.5rem 0;
}
</style>
